/**
 * Dashboard React Query Hooks
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { dashboardApi, DashboardResponse } from '../api/dashboard-api'

/**
 * Get dashboard statistics
 */
export function useDashboardStats(): UseQueryResult<DashboardResponse, Error> {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => dashboardApi.getStats(),
    staleTime: 1000 * 60 * 2, // 2 minutes
    refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
  })
}
